import $ from 'jquery';
import 'bootstrap/js/dist/tab.js';

initTabNavigationHistory();

function initTabNavigationHistory() {
  const $tabToggles = $('[data-toggle="tab"]');

  if ($tabToggles.length < 1 && history && location) {
    return;
  }

  const currentPageTitle = document.title;
  const currentTabHash = location.hash;
  const currentUrlWithoutHash = location.href.replace(location.hash, '');
  let $initialActiveTab = $tabToggles.filter('.active');
  let isFirst = true;

  _showTabOnInit();
  $(window).on('popstate', _onPopState);
  $tabToggles.on('shown.bs.tab', _onShowTab)

  function _showTabOnInit() {
    if (!currentTabHash) {
      return;
    }

    const $currentActiveTab = $tabToggles.filter(`[href="${currentTabHash}"]`);
    const currentTabName = $currentActiveTab.text();
    const newPageTitle = `${currentTabName} | ${currentPageTitle}`;

    $initialActiveTab = $currentActiveTab;
    $currentActiveTab.tab('show');
    history.replaceState(
      {
        tabState: {
          currentActiveTabId: $currentActiveTab.attr('id'),
          currentTabPageTitle: newPageTitle,
        },
      },
      newPageTitle,
      currentUrlWithoutHash + currentTabHash,
    );
    document.title = newPageTitle;
  }

  function _onPopState() {
    // TODO: Prevent skip for very fast history changes
    const tabState = history.state && history.state.tabState;

    if (!tabState) {
      $tabToggles.first().tab('show');
      document.title = currentPageTitle;
      return;
    }

    const {
      currentActiveTabId,
      currentTabPageTitle,
    } = tabState;
    const $currentActiveTab = $('#' + currentActiveTabId);

    $currentActiveTab.tab('show');
    document.title = currentTabPageTitle;
  }

  function _onShowTab(event) {
    const $newActiveTab = $(event.target);
    const isFirstTab = $newActiveTab.get(0) === $tabToggles.first().get(0);
    const currentTabName = $newActiveTab.text();
    const currentTabHash = isFirstTab ? '' : $newActiveTab.attr('href');
    const newPageTitle = `${currentTabName} | ${currentPageTitle}`;
    const currentTabState = history.state && history.state.tabState;
    const isSameAsInitialTab = $newActiveTab.get(0) ===  $initialActiveTab.get(0);
    const newTabState = {
      currentActiveTabId: $newActiveTab.attr('id'),
      currentTabPageTitle: isFirstTab ? currentPageTitle : newPageTitle,
    };
    const isTabStateUnchanged = (isFirstTab && currentTabState === null) ||
      currentTabState && currentTabState.currentActiveTabId === newTabState.currentActiveTabId;

    if ((isFirst && isSameAsInitialTab) || isTabStateUnchanged) {
      isFirst = false;
      return;
    }

    history.pushState(
      {
        tabState: newTabState,
      },
      isFirstTab ? currentPageTitle : newPageTitle,
      currentUrlWithoutHash + currentTabHash
    );

    document.title = isFirstTab ? currentPageTitle : newPageTitle;

    // Force Firefox to iframe resize after tab change
    const $iframe = $($newActiveTab.data('target')).find('iframe');
    if ($iframe.length) {
      $iframe[0].iFrameResizer.resize();
    }
  }
}
